import React, {useContext } from "react";
import Layout from '../../Components/VC/VcCompanyLayout'
import MainMenu from '../../Components/VC/AllMainmenu'
import Table from '../../Components/AllTableComponent'
import Constants from '../../Constants';
import { useLocation } from 'react-router-dom';
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { UserContext } from "../../Contexts/UserContext";
import ToggleDealsViewButton from "../../Components/ToggleDealsView";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import useChartAnalytics from "../../hooks/useChartAnalytics";
/**
 * The function `Vc` is a React component that renders a layout with a top navigation bar, a main
 * section with a primary column and a secondary column, and a bottom section.
 * @returns The function `Vc` returns JSX elements that make up the layout of a page. It includes a top
 * navigation bar, a main section with a primary column and a secondary column, and a bottom section.
 * The primary column contains a filter tag, a main menu, and a table. The secondary column contains a
 * refine search component.
 */
function Vc() {
    // const [showModal, setShowModal] = React.useState(false);
    const location = useLocation(); 
    const { refineSearchFilters, dealsView,isMobile, setDealsView, switchValue, setSwitchValue } = useContext(PeFilterContext);
    const { isDirectoryUser } = useContext(UserContext);

    const { pathname } = useLocation();
    
    // Use chart analytics hook
    const {
        showChartPopup,
        setShowChartPopup,
        currentChartData,
        setCurrentChartData,
        isChartLoading,
        setIsChartLoading,
        currentShowBy,
        fallbackChartData,
        getAvailableShowByOptions,
        handleChartIconClick,
        handleShowByChange,
        interval,
        handleIntervalChange,
        period,
        handlePeriodChange
    } = useChartAnalytics("vc", pathname);
    
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    const dealsViewHandler = (checked) =>{
        setSwitchValue(checked);
        if(checked){ setDealsView(true) }else setDealsView(false);
    }

    return (
        <Layout>
        <div className="flex min-h-screen h-screen flex-col">
                    {/* Top nav*/}
                    {/* Bottom section */}
                    <div className="flex min-h-0 flex-1 overflow-hidden">
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className= {isFromGlobalSearch() ? "min-w-0 flex-1 border-t border-gray-200 flex":"min-w-0 mt-12 flex-1 border-t border-gray-200 flex"}>
                            {/* Primary column */}
                            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED]">
                                <div className="mr-[4.25rem] flex justify-between items-center">
                                <div></div>
                                {/* <div className='px-3'> */}
                                <ToggleDealsViewButton />
                                </div>
                                {/* Your content */}
                                <MainMenu 
                                    active={1} 
                                    menu="vc" 
                                    primaryTypeMasterId={Constants.primaryMasterIds.vcId}
                                    subTypeMasterId={Constants.primaryMasterSubIds.vc_investments_id}
                                    typeId={Constants.moduleIds.companiesId}
                                    exportFileName={Constants.exportNames.vc_company_investment}
                                    handleChartIconClick={handleChartIconClick}
                                    isChartLoading={isChartLoading}
                                /> 
                                <div className='overflow-y-auto'>
                                    <Table menu="vc" sub_type_master_id={Constants.subCategoryIds.vc_investments_id}/>
                                </div>
                                {/* </div> */}
                            </section>
                        </main>
                    </div>                   
                       
                </div>
                
                {/* Chart Popup */}
                {showChartPopup && (
                    <ChartPopup
                        isOpen={showChartPopup}
                        onClose={() => {
                            setShowChartPopup(false);
                            setIsChartLoading(false);
                            setCurrentChartData(null);
                        }}
                        data={currentChartData || fallbackChartData}
                        isLoading={isChartLoading}
                        showBy={currentShowBy}
                        availableShowByOptions={getAvailableShowByOptions()}
                        onShowByChange={handleShowByChange}
                        interval={interval}
                        onIntervalChange={handleIntervalChange}
                        period={period}
                        onPeriodChange={handlePeriodChange}
                        menuType="vc"
                        subType="VC Investments"
                    />
                )}
        </Layout>
    )
}

export default Vc
